var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('hero-header',{attrs:{"page-name":"","hero-title":"Munkalapjaim"}}),_c('v-container',{staticClass:"my-10"},[_c('v-row',{staticClass:"my-10"},[_vm._v("\n      //\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }